import axios from 'axios'
import {getApiUrls, getApiUpdateUrls} from "@/http/base.http";

export function getUser(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}user/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addUser(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}user/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdUser(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}user/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateUser(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}user/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddUserType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/user/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddRole() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/role/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}